// Small UI atoms. Grouped in one file because each is <10 lines and they
// share no internal state — splitting further is over-engineering.

import { useEffect } from 'react';

export const Prio = ({ value }) => (
  <span className={`prio prio-${value}`}>{value}</span>
);

export const StatusPill = ({ value }) => (
  <span className={`status status-${value}`}><span className="dot"/>{value}</span>
);

export const CatTag = ({ value }) => (
  <span className="cat-tag">{value}</span>
);

// Toast — transient status. Optional `action` ({label, onClick}) renders an
// inline button (e.g. 撤回) and extends the default lifetime so the user has
// time to click it; pass `duration` to override (ms).
export const Toast = ({ message, kind, onDone, action, duration }) => {
  useEffect(() => {
    const ms = duration || (action ? 7000 : 2500);
    const t = setTimeout(onDone, ms);
    return () => clearTimeout(t);
  }, [onDone, action, duration]);
  return (
    <div className={`toast ${kind || ''}`} role="status">
      <span>{message}</span>
      {action && (
        <button className="toast-action"
                onClick={() => { action.onClick?.(); onDone(); }}>
          {action.label}
        </button>
      )}
    </div>
  );
};
